import { action, makeObservable } from 'mobx';
import { Runtime } from '../../Runtime';
import { ScheduledTask } from './ScheduledTask';

export class RuntimeSchedule {
  parent: Runtime;

  isProcessBatchTriggered: boolean = false;
  pendingTasks: ScheduledTask[] = [];

  constructor(parent) {
    makeObservable(this);
    this.parent = parent;
  }

  get runtime(): Runtime {
    return this.parent;
  }

  addTask(actionFunc, options) {
    if (options.skipIfContains) {
      if (this.pendingTasks.find(task => task.skipIfContains === options.skipIfContains)) {
        return;
      }
    }

    const task = new ScheduledTask({ action: actionFunc, ...options });
    this.pendingTasks.push(task);
    return task;
  }

  @action.bound
  processCurrentBatch() {
    const todos = this.pendingTasks.slice();
    this.pendingTasks = [];
    this.isProcessBatchTriggered = false;

    for (const task of todos) {
      task.resolve(task.action());
    }
  }
}
